export function cssColorToHex(str: string) {
  const ctx = document.createElement("canvas").getContext("2d");

  if (!ctx) return str;

  ctx.fillStyle = str;
  return ctx.fillStyle;
}
